import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OrganizationApi } from 'api';
import { IOrganization } from 'types';

function useCreate() {
  const queryClient = useQueryClient();
  return useAuthMutation(
    (data: Partial<IOrganization>) => OrganizationApi.post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useCreate;
